var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconPdf(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_5849",
    "data-name": "Group 5849",
    transform: "translate(-2026 -1616)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_108",
    "data-name": "Ellipse 108",
    cx: 30,
    cy: 30,
    r: 30,
    transform: "translate(2026 1616)",
    fill: "#ee7f00"
  }), /*#__PURE__*/React.createElement("g", {
    id: "pdf-file",
    transform: "translate(2042 1629.333)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_283",
    "data-name": "Path 283",
    d: "M120.137,298.285c0-.547-.379-.873-1.049-.873a2.32,2.32,0,0,0-.555.053v1.754a2.106,2.106,0,0,0,.45.034C119.7,299.254,120.137,298.893,120.137,298.285Z",
    transform: "translate(-113.302 -276.835)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_284",
    "data-name": "Path 284",
    d: "M194.412,297.681a2.776,2.776,0,0,0-.608.053v3.886a2.427,2.427,0,0,0,.467.027,1.841,1.841,0,0,0,2.009-2.079A1.7,1.7,0,0,0,194.412,297.681Z",
    transform: "translate(-183.219 -277.066)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_285",
    "data-name": "Path 285",
    d: "M63.965,0H50.257a3.6,3.6,0,0,0-3.632,3.548V16.667H46.27a1.447,1.447,0,0,0-1.464,1.43v8.67A1.447,1.447,0,0,0,46.27,28.2h.355v1.59a3.6,3.6,0,0,0,3.632,3.548h18.7a3.6,3.6,0,0,0,3.631-3.548V8.4ZM48.646,19.661a11.743,11.743,0,0,1,1.881-.124,3,3,0,0,1,1.882.482,1.742,1.742,0,0,1,.658,1.392,1.9,1.9,0,0,1-.566,1.427,2.9,2.9,0,0,1-2,.633,3.692,3.692,0,0,1-.475-.026v2.15H48.646Zm20.315,11.5h-18.7a1.393,1.393,0,0,1-1.407-1.375V28.2H66.286a1.447,1.447,0,0,0,1.464-1.43V18.1a1.447,1.447,0,0,0-1.464-1.43H48.85V3.548a1.393,1.393,0,0,1,1.407-1.373l12.876-.013V6.81a2.491,2.491,0,0,0,2.519,2.46l4.662-.013.052,20.528A1.392,1.392,0,0,1,68.961,31.161Zm-15-5.594V19.661a12.833,12.833,0,0,1,1.882-.124,4.034,4.034,0,0,1,2.521.642A2.637,2.637,0,0,1,59.4,22.445a3.015,3.015,0,0,1-1.023,2.435,4.5,4.5,0,0,1-2.84.776A12.335,12.335,0,0,1,53.956,25.567Zm9.969-3.5v1.106H61.714v2.418h-1.4V19.581H64.08V20.7H61.714V22.07Z",
    transform: "translate(-44.806)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPdf);
export default __webpack_public_path__ + "static/media/icon-pdf.32862ec3589732a0a060a3c08f6d6ee9.svg";
export { ForwardRef as ReactComponent };